import { router } from '@/routes';

export function getCorrelationIdFromRouter() {
  const { params, query } = router.currentRoute.value;
  return (params.sessionid ?? query.correlationId) as string;
}
